import { component } from "picoapp";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

type TimeState = {
  difference: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
};

export const timerAnnouncementBar = component((node: HTMLElement) => {
  const timeZone = node.dataset.timezone;

  const targetDate = node.dataset.targetDate;
  const targetUTCDate = timeZone
    ? dayjs.tz(targetDate, "MM-DD-YYYY", timeZone)
    : dayjs(targetDate);
  const currentUTCDate = dayjs();

  const hoursContainer = node.querySelector<HTMLElement>(
    "[data-hours] [data-tbsp-component='text']"
  );
  const minutesContainer = node.querySelector<HTMLElement>(
    "[data-minutes] [data-tbsp-component='text']"
  );
  const secondsContainer = node.querySelector<HTMLElement>(
    "[data-seconds] [data-tbsp-component='text']"
  );

  if (!hoursContainer || !minutesContainer || !secondsContainer) return;

  const timeDifference = targetUTCDate.diff(currentUTCDate);
  const duration = dayjs.duration(timeDifference);

  const timeState: TimeState = {
    difference: timeDifference,
    hours: Math.floor(duration.asHours()),
    minutes: duration.minutes(),
    seconds: duration.seconds(),
  };

  const updateTimer = ({
    hours,
    minutes,
    seconds,
  }: {
    hours?: number;
    minutes?: number;
    seconds?: number;
  }) => {
    if (hours || hours === 0) {
      hoursContainer.innerHTML = `${hours}`.padStart(2, "0");
    }

    if (minutes || minutes === 0) {
      minutesContainer.innerHTML = `${minutes}`.padStart(2, "0");
    }

    if (seconds || seconds === 0) {
      secondsContainer.innerHTML = `${seconds}`.padStart(2, "0");
    }
  };

  updateTimer({
    hours: timeState.hours,
    minutes: timeState.minutes,
    seconds: timeState.seconds,
  });

  const countdownInterval = setInterval(
    (timer: TimeState) => {
      timer.difference -= 1000;
      const newDuration = dayjs.duration(timer.difference);
      const newHours = Math.floor(newDuration.asHours());
      const newMinutes = newDuration.minutes();
      const newSeconds = newDuration.seconds();

      if (timer.hours !== newHours) {
        timer.hours = newHours;
      }

      if (timer.minutes !== newMinutes) {
        timer.minutes = newMinutes;
      }

      if (timer.seconds !== newSeconds) {
        timer.seconds = newSeconds;
      }

      updateTimer({
        ...(newHours === timer.hours ? { hours: newHours } : {}),
        ...(newMinutes === timer.minutes ? { minutes: newMinutes } : {}),
        ...(newSeconds === timer.seconds ? { seconds: newSeconds } : {}),
      });
    },
    1000,
    timeState
  );

  const stopInterval = () => {
    clearInterval(countdownInterval);
  };

  return () => {
    stopInterval();
  };
});
